(() => {
  document.addEventListener('turbolinks:load', function () {
    const cuponCodeInput = document.querySelector('#coupon_code')
    if (cuponCodeInput) {
      document.querySelector('#coupon_code').addEventListener('focusout', function () {
        this.form.dispatchEvent(new Event('submit', { bubbles: true, cancelable: true }))
      })
    }
  })
})()